import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { getToken } from '../../../../reducers/auth';

export const onSubmit = async (values, dispatch, props) => {
    const {
        token,
        history,
        redirectPath,
        skipPath,
        paginationSkipState,
        dispatchFunction,
        tracking
    } = props;
    let hasError = false;

    if (dispatchFunction) {
        const formValues = {
            ...values,
            formValues: {
                ...props.formValues
            },
            sendLeadsEmail: typeof props.sendLeadsEmail !== 'undefined' ? props.sendLeadsEmail : true
        };

        let request = await dispatch(dispatchFunction(token, formValues));

        hasError = request.error;

        if(hasError && request.payload.request.status === 401){
            await dispatch(getToken());
            request = await dispatch(dispatchFunction(token, formValues));
        }

        hasError = request.error;
    }

    if (tracking && !hasError) {
        tracking();
    }

    if(paginationSkipState && skipPath && !hasError) {
        history.push(`${process.env.PUBLIC_URL}${skipPath}`);
    }

    if (redirectPath &&!paginationSkipState && !hasError) {
        history.push(`${process.env.PUBLIC_URL}${redirectPath}`);
    }
};

const SubmitButton = ({
    dispatch,
    form,
    onClick = () => {},
    className,
    children
}) => (
    <button
        type='button'
        onClick={() => {
            dispatch(submit(form));
            onClick();
        }}
        className={className}
    >
        { children }
    </button>
);

const mapStateToProps = ({ auth: { token } }) => ({
    token
});

export default connect(mapStateToProps)(SubmitButton);
